import { isMacAppStore } from '@/lib/appDistribution';
import React from 'react';
import { Platform, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';
import WorkComposerProjectBar from '@/components/ChatInput/WorkComposerProjectBar';
export default function MacProjectReadOnlyNotice({ name }) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const folderAbove = Platform.OS === 'web' && isXS;
  return <>
    {folderAbove && !!name && <WorkComposerProjectBar projectName={name} />}
    <View accessibilityRole="text" style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 14, padding: 20,
    borderRadius: 18, borderWidth: 1, borderColor: colors.border_color_secondary, backgroundColor: colors.solid_color_block }}>
    <Icon name="laptop" size={23} color={colors.text_color_secondary} />
    <View style={{ flex: 1, minWidth: 0, gap: 6 }}>
      <Text size="m" weight="medium">Connected to a folder on your Mac</Text>
      {!!name && !folderAbove && <Text size="s" weight="medium" numberOfLines={1}>{name}</Text>}
      <Text size="s" color="secondary" style={{ lineHeight: 22 }}>{isMacAppStore() ? 'You can read this chat and view its saved files here. Continue this connected task in the website edition, or start a new cloud task.' : 'You can read this chat and view its saved files here. To send a message or continue this Work task, use the Gab AI Mac app or Remote on your paired phone.'}</Text>
    </View>
  </View>
  </>;
}
